module.exports = __webpack_public_path__ + "img/pic_1.0d2e8438.png";